<template>
  <div class="animated fadeIn">
    <b-button size="sm" variant="secondary" class="new_forms_processed" v-if="processing && !newFormsProcessed">{{ this.$t('FORMS.PROCESSING_STAT') }} <i class="fa fa-spin fa-spinner"></i></b-button>
    <b-button size="sm" v-if="newFormsProcessed > 0" variant="secondary" @click="handleRefresh" class="new_forms_processed">{{ newFormsProcessed }}  {{ newFormsProcessed > 1 ? this.$t('FORMS.PROCESSED_STAT_MANY') : this.$t('FORMS.PROCESSED_STAT_ONE')}}  </b-button>
    <b-tabs class="processed-form" v-model="tabIndex">
      <FormsSearchBar @filterInput="setFilter" @refreshTab="refreshTab" @applyFilters="applyFilters" :title="$t('WORKFLOW.PROCESSED_FORMS')" :eventBus="eventBus" :order="order" :tabIndex="tabIndex"/>
      <b-tab v-for="(tab, index) in tabs" :key=tab.id :title="getTabName(tab.name) | titlize" @click="handleTabChange(tab.role_order)" :disabled="disable_tab">
        <div class="forms-table">
          <b-table v-if="formsLoaded" hover striped show-empty :empty-text="$t('COMMON.NO_RECORD')" responsive="sm" :items="$store.getters.getProcessedData " :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-compare="sortCompare">            
            <template slot="HEAD_group_id" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="HEAD_title" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="title" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.title">{{data.item.title}}</span></template>
            <template slot="HEAD_document_type" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="HEAD_processed" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="HEAD_rejected" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="HEAD_match_type" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="HEAD_updated_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="updated_at" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.updated_at">{{data.item.updated_at}}</span></template>
            <template slot="HEAD_created_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="created_at" slot-scope="data"><span v-b-tooltip.viewport :title="data.item.created_at">{{data.item.created_at}}</span></template>
            <template slot="HEAD_total_page_count" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="HEAD_forms_doc_status" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="forms_doc_status" slot-scope="data"><span v-b-tooltip.viewport :title="formDocumnetStatus[data.item.forms_doc_status]">{{formDocumnetStatus[data.item.forms_doc_status]}}</span></template>
            <template slot="HEAD_download_link" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="download_link" slot-scope="data">
              <div class="btn-group" v-if="data.item.first_form_id && data.item.form_doc_lock === false && order !== -2 && order !== -1 && order !==2">
                  <router-link :to="{ name: 'Verification', params: {id: data.item.first_form_id }}">
                    <b-button variant="secondary" class="btn btn-primary btn-sm"
                              v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('analysis') >= 0 && !data.item.is_rejected"
                              :class="getCSS(data.item.match_type, index, data.item.status, 'analysis')">
                      {{ $t('WORKFLOW.ANALYSIS') }}
                    </b-button>
                  </router-link>
                  <b-button :disabled="data.item.sf_export_status === true" variant="primary" class="btn btn-primary btn-sm"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('salesforce') >= 0 && data.item.forms_doc_status !== formDocStatusEnums['PCSUCCESS'] && !data.item.is_rejected" @click="processJson(data.item, 'salesforce')"
                            v-b-tooltip.hover.viewport :title="$t('COMMON.SLSFRC')"
                            :class="getCSS(data.item.match_type, index, data.item.status, 'salesforce')">
                    <i class="icon-cloud-upload" :ref="'export-salesforce-' + index + '-' + data.item.id"></i>
                    <i class="fa fa-spin fa-spinner hide" :ref="'spinner-salesforce-' + index + '-' + data.item.id"></i>
                  </b-button>
                  <b-button variant="secondary" class="btn btn-primary btn-sm ml-1"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('reject') >= 0 && !data.item.is_rejected && data.item.first_form_id && !data.item.form_doc_lock && formDocumnetStatus[data.item.forms_doc_status] !== 'Completed'"
                            @click="showRejectFormModal(data.item)">
                    Reject
                  </b-button>
                  <b-button variant="secondary" class="btn btn-primary btn-sm"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('recall') >= 0 && data.item.is_rejected && data.item.first_form_id"
                            @click="changeRejectStatus(data.item)">
                    Recall
                  </b-button>
              </div>
              <div class="btn-group" v-else-if = "data.item.form_doc_lock" >
                <b-button variant="dark" class="btn btn-primary btn-sm"
                          @click="multipleUser(data.item.id, data.item.user_name)">
                          {{$t('WORKFLOW.LOCK_TITLE', {'userName': data.item.user_name})}}
                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                </b-button>
              </div>

              <div class="btn-group" v-else-if="data.item.match_type === 'TRIAGING' && data.item.forms_doc_status === formDocStatusEnums['COMPLETED']">
                <div class="text-center">
                  <span>
                    <span style="color: green;font-size: 24px; padding: 2px;">
                    <i class="fa fa-check-circle fa-sm"></i>
                    </span>
                  </span>
                </div>
                <!-- <b-button variant="dark"
                          @click="processedformsInfoModal(data.item)"
                          style="border-radius: 0px"
                          v-b-tooltip.hover.viewport :title="$t('WORKFLOW.REPORT')"
                          class="last-button btn-sm">
                  <i class="fa fa-file-text" aria-hidden="true"></i>
                </b-button> -->
              </div>

              <div class="btn-group" v-else-if= "data.item.sf_export_status === true">
                <div class="text-center">
                  <span>
                    <span style="color: green;font-size: 24px; padding: 2px;">
                    <i class="fa fa-check-circle fa-sm"></i>
                    </span>
                  </span>
                </div>
                <b-button variant="dark"
                          @click="viewRecord(data.item)"
                          style="border-radius: 0px"
                          v-b-tooltip.hover.viewport title="View Record"
                          class="last-button btn-sm">
                  <i class="fa fa-external-link" aria-hidden="true" ></i>
                </b-button>
              </div>

              <div class="btn-group" v-else-if = "!data.item.first_form_id">
                <div class="text-center">
                   <span>
                    <span style="color: red;font-size: 24px;padding: 2px;">
                    <i class="fa fa-check-circle"></i>
                    </span>
                  </span>
                </div>
                <b-button variant="dark"
                          @click="viewRecord(data.item)"
                          style="border-radius: 0px"
                          v-b-tooltip.hover.viewport title="View Record"
                          class="last-button btn-sm">
                  <i class="fa fa-external-link" aria-hidden="true" ></i>
                </b-button>
                <!-- <b-button variant="danger"
                          @click="confirmDelete(data.item)"
                          v-b-tooltip.hover.viewport :title="$t('WORKFLOW.DELETE')"
                          class="last-button">
                  <i class="icon-trash"></i>
                </b-button> -->
              </div>

              <div class="btn-group" v-else>
                <router-link :to="{ name: 'Verification', params: {id: data.item.first_form_id }}">
                    <b-button variant="secondary" class="btn btn-primary btn-sm"
                              v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('analysis') >= 0 && !data.item.is_rejected"
                              :class="getCSS(data.item.match_type, index, data.item.status, 'analysis')">
                      {{ $t('WORKFLOW.ANALYSIS') }}
                    </b-button>
                </router-link>
                <b-button :disabled="data.item.sf_export_status === true" variant="primary" class="btn btn-primary btn-sm"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('salesforce') >= 0" @click="processJson(data.item, 'salesforce')"
                            v-b-tooltip.hover.viewport :title="$t('COMMON.SLSFRC')"
                            :class="getCSS(data.item.match_type, index, data.item.status, 'salesforce')">
                    <i class="icon-cloud-upload" :ref="'export-salesforce-' + index + '-' + data.item.id"></i>
                    <i class="fa fa-spin fa-spinner hide" :ref="'spinner-salesforce-' + index + '-' + data.item.id"></i>
                </b-button>
                <router-link v-if="(data.item.match_type === 'TRIAGING' || data.item.match_type === 'ESF_TRIAGING' || data.item.status === 'ESF_TRIAGING' || order === 2 || order === -2) && data.item.is_rejected === false" :to="order === -2 ? 'modify/' + data.item.id : order === 2 ? 'esf_triaging/' + data.item.id : 'modify/' + data.item.id">
                  <b-button id="tooltip-target-1" class="btn btn-primary btn-sm"
                            variant="secondary"
                            v-b-tooltip.hover.viewport title="Show">
                    <i class="fa fa-eye"></i>
                  </b-button>
                </router-link>
                <!-- <router-link v-if= "data.item.match_type === 'Manual' && data.item.is_rejected === false" :to="'modify/'+ data.item.id">
                  <b-button id="tooltip-target-1" class="btn btn-primary btn-sm"
                            variant="secondary"
                            v-b-tooltip.hover.viewport title="Show">
                    <i class="fa fa-eye"></i>
                  </b-button>
                </router-link> -->
                <b-button :disabled="data.item.sf_export_status === true"
                          v-if="exportRotatedDocs(data.item, index) && index === 0"
                          @click="processRotatedDoc(data.item, 'rotated_docs_sf')"
                          variant="primary"
                          class="btn btn-primary btn-sm"
                          v-b-tooltip.hover.viewport
                          :title="$t('COMMON.SLSFRC')"
                          :class="getCSS(data.item.match_type, index, data.item.status)">
                  <i class="icon-cloud-upload" :ref="'export-rotated_docs_sf-' + data.item.id"></i>
                  <i class="fa fa-spin fa-spinner hide" :ref="'spinner-rotated_docs_sf-' + data.item.id"></i>
                </b-button>
                <!-- <b-button :disabled="data.item.sf_export_status === true"
                          v-if="exportRotatedDocs(data.item, index) && index === 3"
                          @click="processESFDoc(data.item)"
                          variant="primary"
                          class="btn btn-primary btn-sm"
                          v-b-tooltip.hover.viewport
                          :title="$t('COMMON.SLSFRC')"
                          :class="getCSS(data.item.match_type, index, data.item.status)">
                  <i class="icon-cloud-upload" :ref="'export-process_esf_doc-' + data.item.id"></i>
                  <i class="fa fa-spin fa-spinner hide" :ref="'spinner-process_esf_doc-' + data.item.id"></i>
                </b-button> -->
                <!-- <b-button v-if="data.item.match_type === 'TRIAGING'" variant="dark"
                          @click="processedformsInfoModal(data.item)"
                          style="border-radius: 0px"
                          v-b-tooltip.hover.viewport :title="$t('WORKFLOW.REPORT')"
                          class="btn btn-primary btn-sm">
                  <i class="fa fa-file-text" aria-hidden="true"></i>
                </b-button> -->
                <b-button class="btn btn-sm btn-primary"
                          variant="primary"
                          @click="confirmReprocess(data.item)"
                          :disabled="data.item.retry_count >= 3 || data.item.is_rejected"
                          v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('reprocess') >= 0">
                  <i class="icon-refresh"
                      v-b-tooltip.hover.viewport :title="data.item.retry_count >= 3 ? $t('WORKFLOW.MAX_RETRIES') : $t('WORKFLOW.REPROCESS')" ></i>
                </b-button>
                <b-button   class="btn btn-primary btn-sm"
                            variant="secondary"
                            v-b-tooltip.hover.viewport :title="$t('WORKFLOW.MOVE_TO_MATCHED')"
                            :disabled="data.item.is_rejected"
                            @click="moveToMatched(data.item)"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('moveToMatched') >= 0">
                            <i class="fa fa-reply"></i>
                </b-button>
                <!-- <b-button variant="danger"
                          @click="confirmDelete(data.item)"
                          v-b-tooltip.hover.viewport :title="$t('WORKFLOW.DELETE')"
                          class="last-button">
                  <i class="icon-trash"></i>
                </b-button> -->
                <b-button variant="secondary" class="btn btn-primary btn-sm ml-1"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('reject') >= 0 && !data.item.is_rejected && data.item.first_form_id && !data.item.form_doc_lock && formDocumnetStatus[data.item.forms_doc_status] !== 'Completed'"
                            @click="showRejectFormModal(data.item)">
                    Reject
                </b-button>
                <b-button variant="secondary" class="btn btn-primary btn-sm"
                            v-if="allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('recall') >= 0 && data.item.is_rejected && data.item.first_form_id"
                            @click="changeRejectStatus(data.item)">
                    Recall
                </b-button>
              </div>
            </template>
          </b-table>
          <b-row v-else>
            <b-col cols="12">
              <b-card>
                <content-placeholders>
                  <content-placeholders-img :style="{height: '400px'}" />
                </content-placeholders>
              </b-card>
            </b-col>
          </b-row>
          <infinite-loading
            :identifier="infiniteId"
            :distance="distance"
            spinner="spiral"
            @infinite="infiniteHandler"
            ref="infiniteLoading">
              <div slot="no-more"></div>
              <div slot="no-results"></div>
          </infinite-loading>
        </div>
      </b-tab>
    </b-tabs>
    <b-modal hide-header-close centered :title="'FHIR data'" ref="fhirModal" ok-only @ok="clearFhirData">
      <b-container fluid>
        <strong>Demographics</strong>
        <b-row class="mb-1 text-center" v-for="(value, key, index) in fhirValues['demographics']" :key=" 'demographics' + index">
          <b-col cols="6">{{ key | capitalize }} </b-col>
          <b-col cols="6" style="word-wrap: break-word;">{{ value }}</b-col>
        </b-row>
        <hr>
        <strong>Orders</strong>
        <b-row class="mb-1 text-center" v-for="(value, key, index) in fhirValues['orders']" :key=" 'orders' + index">
          <b-col cols="6">{{ key | capitalize }} </b-col>
          <b-col cols="6" style="word-wrap: break-word;">{{ value }}</b-col>
        </b-row>
        <hr>
        <strong>Diagnostics</strong>
        <b-row class="mb-1 text-center" v-for="(value, key, index) in fhirValues['diagnostics']" :key=" 'diagnostics' + index">
          <b-col cols="6">{{ key | capitalize }} </b-col>
          <b-col cols="6" style="word-wrap: break-word;">{{ value }}</b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal hide-header-close centered :title="'Export errors'" ref="validationErrorModal" ok-only @ok="clearValidationErrorData">
      <b-container fluid>
        <strong v-if="!errorKeyAbsent">Errors</strong>
        <b-row class="mb-1 text-center" v-if="errorKeyAbsent" v-for="(value, index) in validationErrors" :key="index">
          <b-col cols="12" style="word-wrap: break-word;">{{ value.reason }}</b-col>
        </b-row>
        <b-row class="mb-1 text-left" v-else v-for="(value, key, index) in validationErrors" :key="key">
          <b-col cols="5">{{ value.key }} </b-col>
          <b-col cols="7" style="word-wrap: break-word;">{{ value.reason }}</b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal hide-header-close centered :title="'Export errors'" ref="exportErrorModal">
      <b-container fluid>
        <div class="mb-3 error_listing" v-if="this.$store.getters.exportErrors && this.$store.getters.exportErrors.length > 0">
        <b-row v-for="(error,index) in this.$store.getters.exportErrors" :key="index">
          <b-col cols="12">
            {{error}}
          </b-col>
        </b-row>
        </div>
        <div class="mb-3 error_listing" v-if="this.$store.getters.otherMedErrors && this.$store.getters.otherMedErrors.length > 0">
        <b-row v-for="(status,index) in this.$store.getters.otherMedErrors" style="text-align: left;" :key="index">
        <b-col cols="12">
            {{index+1}}.{{status}}
          </b-col>
        </b-row>
        </div>
      </b-container>
      <div slot="modal-footer">
        <b-btn size="sm" variant="secondary" @click="clearExportErrorData"> {{ $t('COMMON.OKAY') }} </b-btn>
      </div>
    </b-modal>
    <b-modal hide-header-close centered :title="$t('WORKFLOW.REPROCESS')" ref="reprocessModal" @ok="reprocessFormDoc" :ok-title="$t('WORKFLOW.REPROCESS')" ok-variant="secondary" :cancel-title="$t('COMMON.CANCEL')" cancel-variant="light">
      <b-row>
        <b-input-group>
          <b-col class="p-1 col-4 col-sm-4">
            <label>{{$t('COMMON.TITLE')}}</label>
          </b-col>
          <b-col class="p-1 col-8 col-sm-8">
            <b-form-input class="reprocess-input" :value="selectedFormTitle" disabled />
          </b-col>
        </b-input-group>
        <b-input-group>
          <b-col class="p-1 col-4 col-sm-4">
            <label>{{$t('FORMS.PROCESS_TYPE')}}:</label>
          </b-col>
          <b-col class="p-1 col-4 col-sm-8">
              <b-form-select class="reprocess-input"
                             :plain="true"
                             :options="setOptions"
                             v-model="match_type"
                             @input="handleMatchSelect()"
                             :placeholder="$t('FORMS.MATCH')">
              </b-form-select>
          </b-col>
        </b-input-group>
        <b-input-group v-if="canShowImgPreview">
          <b-col class="p-1 col-4 col-sm-4">
            <label>{{$t('FORMS.FORCED_TEMPLATE')}}:</label>
          </b-col>
          <b-col class="p-1 col-8 col-sm-4">
              <b-form-select class="reprocess-input"
                             :plain="true"
                             :options="templateOptions"
                             v-model="forced_template_doc_id"
                             @input="handleTemplateSelect()"
                             :placeholder="$t('FORMS.TEMPLATE')">
              </b-form-select>
          </b-col>
          <b-col class="p-1 col-12 col-sm-4">
            <zoom-center-transition>
              <img :src="previewImageUrl" class="shadow preview-image">
            </zoom-center-transition>
          </b-col>
        </b-input-group>
      </b-row>
    </b-modal>
    <b-modal size="lg" :title="$t('WORKFLOW.FORM_INFO_HEADER')" no-close-on-esc hide-header-close no-close-on-backdrop centered ref="processedformsInfo">
      <b-container fluid >
        <b-row class="mb-1 text-center">
          <b-col cols="3"><strong>Processed Form Ids</strong></b-col>
          <b-col cols="3"><strong>Title</strong></b-col>
          <b-col cols="3"><strong>Process Type</strong></b-col>
          <b-col cols="3"><strong>Export To Salesforce</strong></b-col>
        </b-row>
        <b-row class="mb-1 text-center" v-for="info in processed_form_info" :key="info.id">
          <b-col cols="3">{{ info.id}} </b-col>
          <b-col cols="3">{{ info.title}} </b-col>
          <b-col cols="3">{{ info.match_type}} </b-col>
          <b-col cols="3" v-if="info.is_export === true"> Export Sucessfull </b-col>
          <b-col cols="3" v-else-if="info.is_export === false"> Export Unsucessfull </b-col>
          <b-col cols="3" v-else-if="info.is_export === null"> Not Yet Exported </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-btn size="sm" variant="secondary" @click="showFormInfo"> {{ $t('COMMON.OKAY') }} </b-btn>
      </div>
    </b-modal>
    <b-modal size="md" title="Record Status" hide-footer centered ref="salesforceReport">
      <div style="text-align: left; overflow: auto;">
        <table class="result" style="width: 100%;">
          <tr class="result" style="background-color: rgb(168 174 179);">
            <th class="result"> S.No </th>
            <th class="result"> Record Type </th>
            <th class="result"> Status </th>
          </tr>
          <tr v-for="(record, record_type, index) in salesforceResponse">
            <td class="result">{{ index+1 }}</td>
            <td class="result" style="text-align: left">
              <a v-if="record.success && record.pc_url" style="color: blue;" target="_blank" :href="record.pc_url">{{ record_type }}</a>
              <a v-else>{{ record_type }}</a>
            </td>
            <td class="result">
              <a v-if="record.pc_url && record.success">success</a>
              <a v-else>failed</a>
            </td>
          </tr>
        </table>
      </div>
    </b-modal>
    <b-modal hide-header-close centered :title="$t('COMMON.DELETE_CONFIRM')" ref="formDelModal" :ok-title="$t('COMMON.DELETE')" :cancel-title="$t('COMMON.CANCEL')" @ok="deleteFormDoc" ok-variant="secondary" cancel-variant="light">
      {{ $t('WORKFLOW.DELETE_FORM', {'FORM_TITLE': selectedFormTitle}) }}
    </b-modal>
    <b-modal v-if="isAdminRole" :title="$t('FORMS.MULTI_USER_MODAL')" ref="lockedFormDocWarning" :ok-title="$t('COMMON.YES')" :cancel-title="$t('COMMON.NO')" @ok="releaseFormDoc()" @cancel="stayWithFormDoc()" ok-variant="secondary" cancel-variant="light" hide-header-close centered>
      <strong>{{$t('WORKFLOW.LOCK_ALERT_MSG')}}</strong>
    </b-modal>
    <b-modal hide-header-close  title="Reject Form" header-bg-variant="light" ref="rejectFormDoc" centered>
        <b-card class="mt-3">
          <b-row class="form-group">
            <b-col cols="12">
              <img src="../../../static/img/exclamation.png">
              <h5>Do you want to reject this document?</h5>
            </b-col>
          </b-row>
        </b-card>
        <div slot="modal-footer">
          <b-btn size="sm" variant="danger" @click="rejectForm(currentFormDoc)"> Confirm </b-btn>
          <b-btn size="sm" variant="light" @click="hideRejectFormDocModal"> {{ $t('COMMON.CANCEL') }} </b-btn>
        </div>
      </b-modal>
      <b-modal hide-header-close  title="Error" header-bg-variant="light" ref="escalatedFormDoc" centered ok-only @ok="hideEscalatedFormDocModal">
        <b-card class="mt-3">
          <b-row class="form-group" style="height: 5px;">
            <p style="font-size: 16px;"> {{ errorMessage }}</p>
          </b-row>
        </b-card>
      </b-modal>
      <b-modal hide-header-close title="Alert" header-bg-variant="light" ref="rejectedDocWarn" centered>
        <div v-html="svg.warningAlert" class="warning-con warning-bg-con-color mb-2"></div>
        <h5>This form has already been rejected. Click <b>Transcribe and Rotate</b> in Salesforce again to reprocess it.</h5>
        <div slot="modal-footer">
          <b-btn size="sm" class="custom-btn" @click="hideRejectedDocWarnModel">Okay</b-btn>
        </div>
      </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import router from '../../router'
import InfiniteLoading from 'vue-infinite-loading'
import FormsSearchBar from '../../components/utils/FormsSearchBar'
import moment from 'moment'
import svg from '../../_svg.js'

export default {
  name: 'processed-form',
  components: {
    FormsSearchBar,
    InfiniteLoading
  },
  data () {
    return {
      filter: '',
      errorMessage: '',
      svg: svg,
      polling: null,
      formsLoaded: false,
      templateOptions: [],
      previewImageUrl: '',
      forced_template_doc_id: null,
      canShowImgPreview: false,
      match_type: null,
      option_keys: [],
      matchOptions: [{ text: 'Select', value: null, disabled: true }],
      tableFields: [
        { key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
        { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' },
        { key: 'total_page_count', label: 'WORKFLOW.PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
        { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left medium-cell-width', thClass: 'text-left medium-cell-width' },
        { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
        // { key: 'match_type', label: 'WORKFLOW.MATCH', sortable: true },
        // { key: 'product', label: 'WORKFLOW.PRODUCT' },
        { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
        { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }
      ],
      tabIndex: 0,
      sortBy: 'group_id',
      sortDesc: true,
      order: 1,
      infiniteId: 1,
      distance: Infinity,
      lastFormId: -1,
      processedData: [],
      tabs: null,
      show: false,
      disable_tab: false,
      newFormsProcessed: 0,
      latestFormId: -1,
      updatedLatestFormId: 0,
      fhirValues: {},
      validationErrors: [],
      selectedFormTitle: '',
      selectedFormDocId: '',
      processing: (this.$route.query.status === 'processing'),
      eventBus: new Vue(),
      searchType: 'title',
      esm_status: '',
      tm_status: '',
      processed_form_info: '',
      id: '',
      confidenceRangeCondition: '',
      confidenceFromValue: 0,
      confidenceToValue: 100,
      confidenceLimitValue: 100,
      dateRangeType: 'Today',
      fromDate: '',
      toDate: '',
      engagementProgram: null,
      productType: '',
      formDocStatus: [['1', '2', '3', '4', '6', '7', '8', '10', '11', '12']],
      salesforceResponse: null,
      formDocumnetStatus: {
        1: 'New',
        2: 'In Progress',
        3: 'Partially Completed',
        4: 'Completed',
        5: 'Rejected',
        6: 'Recalled',
        7: 'Integration Success',
        8: 'Integration Failed',
        9: 'Document Moved To SF',
        10: 'Validated',
        11: 'Pending',
        12: 'Triaged'
      },
      formDocStatusEnums: {
        NEW: 1,
        INPROGRESS: 2,
        PARTIALLY_COMPLETED: 3,
        COMPLETED: 4,
        REJECTED: 5,
        RECALLED: 6,
        PCSUCCESS: 7,
        PCFAILED: 8,
        DOCUMENT_MOVED_TO_SF: 9,
        VALIDATED: 10,
        PENDING: 11,
        TRIAGED: 12
        // PCPARTIAL: 7
      },
      latestFormStatus: '',
      refreshShowTriagingTab: false,
      currentFormDoc: null,
      errorKeyAbsent: false
    }
  },
  computed: {
    ...mapGetters(['idToken', 'isAdmin', 'isAdminRole', 'accountId', 'selectedRolesData', 'userId', 'userRole', 'userRoleOrder', 'prevFormsTab', 'localTime', 'selectTriageStatus', 'selectAgentStatus', 'selectUnmatchStatus', 'selectEsfTriageStatus']),
    checkAuth: function () {
      let order = parseInt(this.order)
      let userRoleOrder = parseInt(this.userRoleOrder)
      return (order === userRoleOrder)
    },
    setOptions () {
      this.matchOptions = [{ text: this.$t('UPLOAD_DROPDOWN.SELECT'), value: null, disabled: true }]
      this.matchOptions = this.matchOptions.concat(this.option_keys.map(processType => { return { text: this.$t('UPLOAD_DROPDOWN.' + processType.key), value: processType.value } }))
      return this.matchOptions
    }
  },
  watch: {
    tabIndex: function () {
      if (this.order === 1) {
        // Agent Tab
        this.tableFields = [
          { key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
          { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' },
          { key: 'document_type', label: 'WORKFLOW.DOCUMENT_TYPE', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          { key: 'processed', label: 'WORKFLOW.PROCESS_PAGE_COUNT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          // { key: 'match_type', label: 'WORKFLOW.MATCH', sortable: true },
          { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true },
          // { key: 'sf_export_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          // { key: 'product', label: 'WORKFLOW.PRODUCT' },
          { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left xmedium-cell-width', thClass: 'text-left xmedium-cell-width' },
          { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }
        ]
      } else if (this.order === -1) {
        // Unmatched Tab
        this.tableFields = [
          { key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
          { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' },
          { key: 'processed', label: 'WORKFLOW.MATCHED_PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
          { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left medium-cell-width', thClass: 'text-left medium-cell-width' },
          { key: 'rejected', label: 'WORKFLOW.REJECT_PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
          // { key: 'match_type', label: 'WORKFLOW.MATCH', sortable: true },
          { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left xmedium-cell-width', thClass: 'text-left xmedium-cell-width' },
          { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }
        ]
      } else {
        // Triaging
        this.tableFields = [
          { key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
          { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' },
          { key: 'total_page_count', label: 'WORKFLOW.PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
          { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left medium-cell-width', thClass: 'text-left medium-cell-width' },
          { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
          { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }
        ]
      }
    }
  },
  created () {
    let {caseId, fileId, contentDocumentId, signatureDate, esfCaseId, documentSplit} = this.$route.query
    contentDocumentId = contentDocumentId === 'undefined' ? null : contentDocumentId
    signatureDate = signatureDate === 'undefined' ? null : signatureDate
    // If process_category is ESF, always use pullEsfDocument
    if (documentSplit === 'true' && caseId) {
      console.log('Using pullEsfDocument for ESF process category with caseId:', caseId)
      this.pullSplitDocument(caseId, fileId)
    } else if (caseId && fileId) {
      this.pullMckessonDocument(caseId, fileId)
    } else if (caseId && (contentDocumentId || signatureDate)) {
      this.pullExistingPatientDoc(caseId, contentDocumentId, signatureDate)
    } else if (caseId) {
      this.pullDocument(caseId)
    } else if (esfCaseId) {
      this.pullEsfDocument(esfCaseId)
    }
    this.tabs = [{name: 'Triaging', role_order: -2}]
    let tabElement = _.slice(this.selectedRolesData, 0, this.userRoleOrder)
    this.tabs = this.tabs.concat(tabElement)
    if (_.isEmpty(tabElement) && this.isAdminRole) {
      this.tabs.push({name: 'admin', role_order: 1})
      this.$store.commit('setUserRoleOrder', 1)
    }
    this.tabs.push({name: 'Unmatched', role_order: -1})
    this.tabs.push({ name: 'ESF Triaging', role_order: 2 })
    if (this.prevFormsTab === null) {
      this.tabIndex = 0
      this.infiniteId = -2
      this.order = -2
    } else {
      this.tabIndex = this.prevFormsTab
      this.order = this.tabs[this.tabIndex].role_order
      this.infiniteId = this.tabs[this.tabIndex].role_order
    }
    this.tabs = this.tabs.map(tab => {
      if (tab.role_order === 1 && this.isAdminRole) {
        return {name: 'Admin', role_order: 1}
      } else {
        return tab
      }
    })
    this.handleFilterChanges()
    this.$store.commit('setRefs', this.$refs)
    this.$store.commit('setPrevFormsTab', this.tabIndex)
    this.fetchProcessTypes()
    this.fetchTemplateOptions()
    this.fetchNewForms()
    this.polling = setInterval(() => {
      this.fetchNewForms()
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.polling)
    this.$store.dispatch('updateProcessedData', [])
    this.setDefaultProcessCategory()
  },
  methods: {
    exportRotatedDocs (item, index) {
      const btnName = this.tabs[index].name === 'Triaging' ? 'rotated_docs_sf' : 'esfTriagedDocs'
      const allowed = this.allowedExports(item.match_type, index, item.status, item.forms_doc_status).indexOf(btnName) >= 0
      const typeOrRotated = ['ESF_TRIAGING', 'TRIAGING'].includes(item.match_type) || item.is_rotated
      const isTrigaingRotation = (this.tabs[index].name === 'Triaging' && item.is_rotated === true) || this.tabs[index].name === 'ESF Triaging'
      return allowed && typeOrRotated && isTrigaingRotation
    },
    getTabIndex (processCat) {
      const config = {
        fax: { tabIndex: 0, infiniteId: -2, order: -2 },
        esf: { tabIndex: 3, infiniteId: 2, order: 2 }
      }

      const settings = config[processCat] || config.fax

      this.tabIndex = settings.tabIndex
      this.infiniteId = settings.infiniteId
      this.order = settings.order
    },
    setDefaultProcessCategory () {
      this.tabIndex = 0
    },
    pullDocument (caseId) {
      Vue.axios.post('form_docs/document', {'inbound_doc_case_id': caseId}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          const {error} = res.data
          if (error) {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
            this.$router.replace('/process/processed')
          } else {
            this.processing = true
            Vue.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' })
            this.$router.replace('/process/processed?status=processing')
          }
        })
        .catch(err => {
          if (err.status === 401) {
            console.error('Session Exipred')
          } else {
            Vue.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' })
          }
          console.log(err)
        })
    },
    pullEsfDocument (caseId) {
      console.log('pullEsfDocument called with caseId:', caseId)
      Vue.axios.post('form_docs/document', {'inbound_doc_case_id': caseId, 'process_category': 'ESF'}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          const {error} = res.data
          if (error) {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
            this.$router.replace('/process/processed')
          } else {
            this.processing = true
            Vue.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' })
            this.$router.replace('/process/processed?status=processing')
          }
        })
        .catch(err => {
          if (err.status === 401) {
            console.error('Session Exipred')
          } else {
            Vue.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' })
          }
          console.log(err)
        })
    },
    pullSplitDocument (caseId, fileId) {
      console.log('pullEsfDocument called with caseId:', caseId)
      const payload = {
        inbound_doc_case_id: caseId,
        process_category: 'ESF',
        content_version_id: fileId
      }
      Vue.axios.post('form_docs/split_document', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          const {error} = res.data
          if (error) {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
            this.$router.replace('/process/processed')
          } else {
            this.processing = true
            Vue.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' })
            this.$router.replace('/process/processed?status=processing')
          }
        })
        .catch(err => {
          if (err.status === 401) {
            console.error('Session Exipred')
          } else {
            Vue.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' })
          }
          console.log(err)
        })
    },
    pullMckessonDocument (caseId, fileId) {
      Vue.axios.post('form_docs/mckessonDocument', {'inbound_doc_case_id': caseId, 'content_version_id': fileId}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          const {error} = res.data
          if (error) {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
            this.$router.replace('/process/processed')
          } else {
            this.processing = true
            Vue.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' })
            this.$router.replace('/process/processed?status=processing')
          }
        })
        .catch(err => {
          Vue.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' })
          console.log(err)
        })
    },
    pullExistingPatientDoc (caseId, contentDocumentId, signatureDate) {
      Vue.axios.post('form_docs/existing_patient_doc', {'inbound_doc_case_id': caseId, 'content_document_id': contentDocumentId, 'signature_date': signatureDate}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          const {error} = res.data
          if (error) {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
            this.$router.replace('/process/processed')
          } else {
            this.processing = true
            Vue.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' })
            this.$router.replace('/process/processed?status=processing')
          }
        })
        .catch(err => {
          Vue.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' })
          console.log(err)
        })
    },
    showRejectFormModal (form) {
      this.currentFormDoc = form
      this.$refs.rejectFormDoc.show()
    },
    sortCompare (aRow, bRow, key) {
      if (key === 'created_at' || key === 'updated_at') {
        const a = new Date(aRow[key])
        const b = new Date(bRow[key])
        return a - b
      }
      return null
    },
    handleFilterChanges () {
      if (this.order === -2) {
        if (this.selectTriageStatus && this.selectTriageStatus.length >= 0) {
          this.formDocStatus = this.selectTriageStatus.map(obj => obj.value)
        } else {
          this.formDocStatus = ['1', '2', '3', '4', '6', '7', '8', '10', '11', '12', '5']
        }
      } else if (this.order === 2) {
        if (this.selectEsfTriageStatus && this.selectEsfTriageStatus.length >= 0) {
          this.formDocStatus = this.selectEsfTriageStatus.map(obj => obj.value)
        } else {
          this.formDocStatus = ['1', '2', '3', '4', '6', '7', '8', '10', '11', '12', '5']
        }
      } else if (this.order === 1) {
        if (this.selectAgentStatus && this.selectAgentStatus.length >= 0) {
          this.formDocStatus = this.selectAgentStatus.map(obj => obj.value)
        } else {
          this.formDocStatus = ['2', '6', '7', '8', '10', '11', '5']
        }
      } else {
        if (this.selectUnmatchStatus && this.selectUnmatchStatus.length >= 0) {
          this.formDocStatus = this.selectUnmatchStatus.map(obj => obj.value)
        } else {
          this.formDocStatus = ['2', '6', '7', '8', '10', '11', '5']
        }
      }
    },
    hideRejectFormDocModal () {
      this.currentFormId = null
      this.$refs.rejectFormDoc.hide()
    },
    hideEscalatedFormDocModal () {
      this.$refs.escalatedFormDoc.hide()
      this.errorMessage = null
    },
    rejectForm: function (form) {
      let res = {
        formDocId: form.id
      }
      Vue.axios.post('form_docs/reject_form_docs', res, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.processedData.map(data => {
            if (data.id === form.id) {
              form.is_rejected = true
              form.forms_doc_status = res.data.status
              if (data.time_status === true) {
                let stillUtc = moment.utc(res.data.updatedat).toDate()
                let localTime = moment(stillUtc).local().format('MMMM DD,YYYY HH:mm')
                form.updated_at = localTime
              }
            }
          })
          this.hideRejectFormDocModal()
          Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'success' })
          Vue.toasted.show(`Form will remain in the system for ${res.data.retention_time} hours`, { icon: 'chain-broken', type: 'success' })
        })
        .catch(err => {
          console.log(err)
          Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
        })
    },
    changeRejectStatus: function (formDoc) {
      let res = {
        formDocId: formDoc.id
      }
      Vue.axios.post('form_docs/recall_form_docs', res, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (formDoc.status === 'TRIAGING') {
            this.$router.push(`/process/modify/${formDoc.id}`)
          } else if (formDoc.status === 'ESF_TRIAGING') {
            this.$router.push(`/process/esf_triaging/${formDoc.id}`)
          } else {
            this.$router.push(`/process/forms/${formDoc.first_form_id}`)
          }
          formDoc.forms_doc_status = res.data.status
          Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'success' })
        })
        .catch(err => {
          console.log(err)
          if (err.status === 400 && err.data.status === 5) {
            this.errorMessage = err.data.message
            this.$refs.escalatedFormDoc.show()
            formDoc.first_form_id = null
          } else {
            Vue.toasted.show(err.data.message, { icon: 'chain-broken', type: 'error' })
          }
          this.$refs.rejectedDocWarn.show()
        })
    },
    hideRejectedDocWarnModel () {
      this.$refs.rejectedDocWarn.hide()
      this.refreshTab(this.tabIndex, this.order)
    },
    showSalesforceReport: function (title, formDocId, data) {
      Vue.axios.get('form_docs/' + formDocId + '/get_salesforce_response', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.salesforceResponse = res.data.salesforce_resp
          this.$refs.salesforceReport.show()
        })
        .catch(error => {
          if (error.status === 401) {
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    viewRecord: function (data) {
      window.open(data.salesforce_urls.case_url, '_blank')
    },
    fetchProcessTypes: function () {
      Vue.axios.get('/settings/process_types/account_process_types', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.option_keys = res.data.account_process_types.map(processType => { return { key: processType.key, value: processType.value } })
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplateOptions () {
      Vue.axios.get('/template_docs/list_options', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.templateOptions = response.data.template_docs
        }, error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          }
          console.log(error)
        })
    },
    downloadEligibilityReport (id) {
      Vue.axios.post('/forms/get_eligibility_report', {form_doc_id: id}, { headers: { Authorization: `Bearer ${this.idToken}` }, responseType: 'blob' })
        .then(res => {
          const url = window.URL.createObjectURL(new window.Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'eligibility.pdf')
          document.body.appendChild(link)
          link.click()
        })
        .catch(err => console.log(err))
    },
    handleMatchSelect () {
      if (this.match_type === -4 && this.templateOptions.length > 0) {
        this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + this.templateOptions[0].image_url
        this.forced_template_doc_id = this.templateOptions[0].value
        this.canShowImgPreview = true
      } else {
        this.forced_template_doc_id = this.match_type
        this.canShowImgPreview = false
      }
    },
    handleTemplateSelect () {
      var thisObj = this
      var selectedOpt = _.find(this.templateOptions, function (topt) { return topt.value === thisObj.forced_template_doc_id })
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedOpt.image_url
    },
    fetchNewForms () {
      console.log(this.lastFormId)
      Vue.axios.get('/form_docs/new_forms?latest_form=' + this.latestFormId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          // update latestFormId only on first call
          if (this.latestFormId === -1) { this.latestFormId = res.data.latest_form }
          this.updatedLatestFormId = res.data.latest_form
          if (this.lastFormId !== this.updatedLatestFormId && res.data.new_forms === 0) {
            this.latestFormId = res.data.latest_form
          }
          this.newFormsProcessed = res.data.new_forms
          this.esm_status = res.data.esm_status
          this.tm_status = res.data.tm_status
          this.latestFormStatus = res.data.status
          this.refreshShowTriagingTab = res.data.all_triaging
        })
        .catch(error => {
          console.log('Error while Polling :', error)
        })
    },
    handleRefresh: function () {
      let userRoleOrder = parseInt(this.userRoleOrder)
      if (this.$route.query.status === 'processing') {
        this.processing = false
        // if (this.esm_status === 'no') {
        //   Vue.toasted.show(this.$t('COMMON.ESM'))
        // }
        // if (this.tm_status === 'no') {
        //   Vue.toasted.show(this.$t('COMMON.TM'))
        // }
        this.$router.replace('/process/processed')
      }
      if (this.refreshShowTriagingTab) {
        this.tabIndex = 0
        this.refreshTab(this.tabIndex, -2)
      } else if (this.latestFormStatus === 'ESF_TRIAGING') {
        this.getTabIndex('esf')
        this.refreshTab(this.tabIndex, this.order)
      } else {
        if (this.latestFormStatus === 'unmatched') {
          this.tabIndex = this.tabs.findIndex(tab => tab.role_order === -1)
          this.order = -1
        } else {
          this.tabIndex = Number(this.userRoleOrder)
          this.order = userRoleOrder
        }
        this.refreshTab(this.tabIndex, this.order)
      }
    },
    infiniteHandler: function ($state) {
      let vm = this
      let order = this.order
      let lastFormId = this.lastFormId
      let filter = this.filter
      let searchType = this.searchType
      let dateRangeType = this.dateRangeType
      let fromDate = dateRangeType === '' ? '' : moment(this.fromDate).format('YYYY-MM-DD HH:mm:ss')
      let toDate = dateRangeType === '' ? '' : moment(this.toDate).format('YYYY-MM-DD HH:mm:ss')
      let productType = this.productType
      var status = order === 2 ? 'ESF_TRIAGING'
        : order > 0 ? 'stage_' + order
          : order === -1 ? 'unmatched'
            : 'TRIAGING'
      let params = {
        forms_doc_status: this.formDocStatus,
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      }
      Vue.axios.get('/form_docs/status_forms/?status=' + status + '&lastFormId=' + lastFormId + '&searchType=' + searchType + '&filter=' + encodeURIComponent(filter.toString()) + '&dateRangeType=' + dateRangeType + '&fromDate=' + fromDate + '&toDate=' + toDate + '&productType=' + productType + '&engagement_program=' + this.engagementProgram, { headers: { Authorization: `Bearer ${vm.idToken}` }, params: params })
        .then(res => {
          let formDocs = res.data.form_docs
          formDocs.map(element => {
            // if (this.order === 2) { // Assuming order 2 is ESF Triaging
            //   console.log(`Form ID: ${element.id}, Match Type: ${element.match_type}, Is Rejected: ${element.is_rejected}`)
            // }
            if (element.form_doc_lock === true) {
              element._rowVariant = 'gray-700'
            } else if (this.formDocumnetStatus[element.forms_doc_status] === 'Integration Failed') {
              element._rowVariant = 'danger'
            } else {
              element._rowVariant = 'none'
            }
          })
          if (formDocs.length && this.filter === res.data.meta.filter) {
            this.sortBy = 'group_id'
            this.sortDesc = true
            if (lastFormId === -1) {
              this.processedData = formDocs
            } else {
              this.processedData = this.processedData.slice().concat(formDocs)
            }
            this.$store.dispatch('updateProcessedData', this.processedData)
            this.formsLoaded = true
            this.disable_tab = false
            this.distance = 100
            this.latestFormId = Math.max(this.latestFormId, this.processedData[0].id)
            this.newFormsProcessed = this.updatedLatestFormId - this.latestFormId
            this.lastFormId = formDocs[formDocs.length - 1]['id']
            $state.loaded()
            if (this.$store.getters.exportFormDocID) {
              let data = this.processedData.filter(data => { return data.id === parseInt(this.$store.getters.exportFormDocID) })
              if (data && data.length > 0) {
                this.$nextTick(() => {
                  this.$store.commit('setExportFormDocID', null)
                  this.processJson(data[0], 'salesforce')
                })
              }
            } else if (this.$store.getters.rotatedDocFormDocId) {
              let data = this.processedData.filter(data => { return data.id === parseInt(this.$store.getters.rotatedDocFormDocId) })
              if (data && data.length > 0) {
                this.$nextTick(() => {
                  this.$store.commit('setRotatedDocFormDocId', null)
                  this.processRotatedDoc(data[0], 'rotated_docs_sf')
                })
              }
            }
          } else if (!formDocs.length) {
            this.formsLoaded = true
            this.disable_tab = false
            this.distance = 100
            $state.complete()
          }
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            this.disable_tab = false
          }
        })
    },
    multipleUser (id) {
      if (this.isAdminRole) {
        this.$refs.lockedFormDocWarning.show()
        this.id = id
      }
    },
    releaseFormDoc () {
      Vue.axios.get('/forms/update_form_doc_lock', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { id: this.id } })
        .then(res => {
          this.processedData = this.$store.getters.getProcessedData
          var form = this.processedData.filter(temp => { return temp.id === this.id })
          form[0].form_doc_lock = false
          form[0]._rowVariant = 'none'
          this.$store.dispatch('updateProcessedData', this.processedData)
        })
        .catch(error => {
          console.log(error)
        })
    },
    stayWithFormDoc () {
      this.$refs.lockedFormDocWarning.hide()
    },
    handleTabChange (order) {
      this.resetFilterValues()
      this.eventBus.$emit('resetFilterModalValues')
      this.disable_tab = true
      this.formsLoaded = false
      this.$store.commit('setPrevFormsTab', this.tabIndex)
      this.order = order
      this.distance = Infinity
      this.lastFormId = -1
      this.processedData = []
      this.$store.dispatch('updateProcessedData', [])
      this.infiniteId = order
      this.handleFilterChanges()
    },
    resetFilterValues () {
      this.filter = ''
      this.searchType = 'title'
      this.dateRangeType = 'Today'
      this.fromDate = ''
      this.toDate = ''
      this.productType = ''
      this.formDocStatus = ''
    },
    allowedExports (matchType, tabIndex, status, formDocStatus = null) {
      var allowedExportButtons
      let currTabIndex = 1
      currTabIndex = Number(this.userRoleOrder)
      if (currTabIndex === tabIndex) {
        switch (matchType.split(',')[0]) {
          case 'Auto':
          case 'Manual':
            allowedExportButtons = (status === 'accepted' || this.formDocumnetStatus[formDocStatus] === 'Integration Failed')
              ? ['analysis', 'download', 'csv', 'salesforce', 'rems', 'edi_837', 'ftp', 'otrf', 'ehr', 'fhir', 'delete', 'reject', 'recall']
              : ['analysis', 'download', 'rems', 'delete', 'reject', 'recall']
            break
          case 'Insurance card':
          case 'Multipage insurance card':
          case 'Drivers License/Voter ID':
            allowedExportButtons = (status === 'accepted')
              ? ['analysis', 'download', 'salesforce', 'edi_837', 'ftp', 'delete']
              : ['analysis', 'download', 'delete']
            break
          case 'Plain Text':
          case 'Lease Document':
            allowedExportButtons = (status === 'accepted')
              ? ['analysis', 'download', 'edi_837', 'ftp', 'delete']
              : ['analysis', 'download', 'delete']
            break
          case 'Invoice':
          case 'Excel Workbook':
            allowedExportButtons = (status === 'accepted')
              ? ['analysis', 'download', 'csv', 'quickbooks', 'edi_837', 'ftp', 'delete']
              : ['analysis', 'download', 'delete']
            break
          default:
            allowedExportButtons = ['analysis', 'download', 'delete', 'reject', 'recall']
        }
      } else if (this.order === -1) {
        if (this.formDocumnetStatus[formDocStatus] === 'Integration Failed') {
          if (status === 'unmatched_accepted') {
            allowedExportButtons = ['analysis', 'download', 'salesforce', 'reject', 'recall']
          }
        } else if (this.formDocumnetStatus[formDocStatus] === 'Validated') {
          if (status === 'unmatched_accepted') {
            allowedExportButtons = ['analysis', 'download', 'salesforce', 'reject', 'recall']
          }
        } else {
          allowedExportButtons = ['analysis', 'download', 'moveToMatched', 'reprocess', 'reject', 'recall']
        }
      } else if (this.order === -2) {
        if (status === 'TRIAGING') {
          allowedExportButtons = ['reject', 'recall', 'rotated_docs_sf']
        } else {
          allowedExportButtons = ['analysis', 'download', 'moveToMatched']
        }
      } else if (this.order === 2) {
        if (status === 'ESF_TRIAGING') {
          allowedExportButtons = ['reject', 'recall', 'esfTriagedDocs']
        } else {
          allowedExportButtons = ['analysis', 'download', 'moveToMatched']
        }
      } else {
        allowedExportButtons = ['analysis', 'download', 'moveToMatched']
      }
      return allowedExportButtons
    },
    getCSS (matchType, tabIndex, status, type = null) {
      const btnName = type === null ? (this.tabs[tabIndex].name === 'Triaging' ? 'rotated_docs_sf' : 'esfTriagedDocs') : type
      var allowedExportButtons = this.allowedExports(matchType, tabIndex, status)
      return {
        'first-button': (allowedExportButtons.indexOf(btnName) === 0),
        'last-button': (allowedExportButtons.indexOf(btnName) === (allowedExportButtons.length - 1))
      }
    },
    setFilter (filter) {
      this.filter = filter
    },
    getTabName: function (name) {
      if (name === 'unmatched') {
        return this.$t('PROFILE.ROLES.UNMATCHED')
      } else if (name === 'admin') {
        return this.$t('PROFILE.ROLES.ADMIN')
      } else {
        return name
      }
    },
    refreshTab (tabIndex, order) {
      this.filter = ''
      this.tabIndex = tabIndex
      this.disable_tab = true
      this.formsLoaded = false
      this.newFormsProcessed = 0
      this.order = order
      this.latestFormId = this.updatedLatestFormId
      this.distance = Infinity
      this.lastFormId = -1
      this.processedData = []
      this.$store.dispatch('updateProcessedData', [])
      this.eventBus.$emit('resetFilter')
      this.$refs.infiniteLoading[this.tabIndex].$emit('$InfiniteLoading:reset')
    },
    applyFilters (searchType, searchText, dateRangeType, fromDate, toDate, engagementProgram, productType, formDocStatus) {
      this.filter = searchText
      this.searchType = searchType
      this.dateRangeType = dateRangeType
      this.fromDate = fromDate
      this.toDate = toDate
      this.formDocStatus = formDocStatus
      // this.productType = productType
      this.disable_tab = true
      this.formsLoaded = false
      this.distance = Infinity
      this.lastFormId = -1
      this.processedData = []
      this.$store.dispatch('updateProcessedData', this.processedData)
      this.$refs.infiniteLoading[this.tabIndex].$emit('$InfiniteLoading:reset')
    },
    processExport (form, type) {
      if (type === 'quickbooks') {
        this.authenticateQB(form, type)
      } else {
        this.processJson(form, type)
      }
    },
    authenticateQB (form, type) {
      Vue.axios.post('auth/verify', { service: type }, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.verified) {
            this.processJson(form, type)
          } else {
            router.push('/auth?redirect_to=' + window.location.href + '&service=quickbooks')
          }
        })
    },
    processedApiRems (templateId, formDocId) {
      let exportRef = this.$refs['export-rems-' + formDocId][0]
      let spinnerRef = this.$refs['spinner-rems-' + formDocId][0]
      exportRef.style.display = 'none'
      spinnerRef.style.display = 'inherit'
      Vue.axios.post('/rems/rems_sf/rems_export_processed_results', {formDocId, templateId}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
        })
        .catch(err => {
          console.log(err)
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show('failed during export', { icon: 'chain-broken', type: 'error' })
        })
    },
    processRotatedDoc (form, type) {
      let data = { ids: form.form_ids }
      let exportRef = this.$refs['export-rotated_docs_sf-' + form.id][0]
      let spinnerRef = this.$refs['spinner-rotated_docs_sf-' + form.id][0]
      exportRef.style.display = 'none'
      spinnerRef.style.display = 'inherit'
      Vue.axios.post('exports/' + form.id + '/' + type, data, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          if (res.data.status === 'success') {
            var message = res.data.message
            this.processedData.map((data) => {
              if (data.id === form.id) {
                form.sf_export_status = true
                form.forms_doc_status = res.data.forms_doc_status
                form.processed = 0
                form.first_form_id = null
              }
              return data
            })
            form._rowVariant = 'none'
            Vue.toasted.show(message)
            if (this.is_export_error_modal) {
              this.$refs.exportErrorModal.show()
            }
          } else {
            if (res.data.status === 'failed') {
              form._rowVariant = 'danger'
              form.sf_export_status = false
              form.forms_doc_status = res.data.forms_doc_status
              this.validationErrors = res.data.errors
              this.$refs.validationErrorModal.show()
            }
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          console.log(error)
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    },
    processESFDoc (form) {
      let data = { ids: form.form_ids }
      let exportRef = this.$refs['export-process_esf_doc-' + form.id][0]
      let spinnerRef = this.$refs['spinner-process_esf_doc-' + form.id][0]
      exportRef.style.display = 'none'
      spinnerRef.style.display = 'inherit'
      Vue.axios.post('form_docs/process_esf_doc', data, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          if (res.data.status === 'success') {
            var message = res.data.message
            this.processedData.map((data) => {
              if (data.id === form.id) {
                form.sf_export_status = true
                form.forms_doc_status = res.data.forms_doc_status
                form.processed = 0
                form.first_form_id = null
              }
              return data
            })
            form._rowVariant = 'none'
            Vue.toasted.show(message)
            if (this.is_export_error_modal) {
              this.$refs.exportErrorModal.show()
            }
          } else {
            if (res.data.status === 'failed') {
              form._rowVariant = 'danger'
              form.sf_export_status = false
              form.forms_doc_status = res.data.forms_doc_status
              this.validationErrors = res.data.errors
              this.$refs.validationErrorModal.show()
            }
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          console.log(error)
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    },
    processJson (form, type) {
      var data = { ids: form.form_ids }
      var exportRef = this.$refs['export-' + type + '-' + this.tabIndex + '-' + form.id][0]
      var spinnerRef = this.$refs['spinner-' + type + '-' + this.tabIndex + '-' + form.id][0]
      exportRef.style.display = 'none'
      spinnerRef.style.display = 'inherit'
      Vue.axios.post('exports/' + form.id + '/' + type, data, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          res.data.errors = res.data.errors.filter(item => item.key !== 'sign/date_missing')
          if (res.data.status === 'success') {
            var type = res.data.type
            var message = res.data.message
            let mimeType
            let fileType
            let blob
            let link
            switch (type) {
              case 'download':
                let processedData = res.data.form
                mimeType = (type === 'download') ? 'application/json' : 'text/plain'
                fileType = (type === 'download') ? '.json' : '.txt'
                blob = new window.Blob([JSON.stringify(processedData)], { type: mimeType })

                link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = form.title + fileType
                document.body.appendChild(link)
                link.click()
                // case 'ftp':
                //   let processedData = res.data.form
                //   let mimeType = (type === 'download') ? 'application/json' : 'text/plain'
                //   let fileType = (type === 'download') ? '.json' : '.txt'
                //   let blob = new window.Blob([JSON.stringify(processedData)], { type: mimeType })

                //   let link = document.createElement('a')
                //   link.href = window.URL.createObjectURL(blob)
                //   link.download = form.title + fileType
                //   document.body.appendChild(link)
                //   link.click()
                break
              case 'csv':
                let csvData = res.data.csv_data
                mimeType = 'text/plain'
                fileType = '.csv'
                blob = new window.Blob([csvData], { type: mimeType })
                link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = form.title + fileType
                document.body.appendChild(link)
                link.click()
                break
              case 'edi_837':
                let processedDataHL7 = res.data.form
                mimeType = (type === 'download') ? 'application/json' : 'text/plain'
                fileType = (type === 'download') ? '.json' : '.txt'
                blob = new window.Blob([processedDataHL7], { type: mimeType })
                link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = form.title + fileType
                document.body.appendChild(link)
                link.click()
                break
              case 'otrf':
                let processedDataOTRF = res.data.result
                mimeType = (type === 'download') ? 'application/json' : 'text/plain'
                fileType = (type === 'download') ? '.json' : '.txt'
                blob = new window.Blob([processedDataOTRF], { type: mimeType })

                link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = form.title + fileType
                document.body.appendChild(link)
                link.click()
                break
              case 'salesforce':
                this.processedData.map((data) => {
                  if (data.id === form.id) {
                    form.sf_export_status = true
                    form.forms_doc_status = res.data.forms_doc_status
                    form.processed = 0
                    form.first_form_id = null
                  }
                  return data
                })
                form._rowVariant = 'none'
                Vue.toasted.show(message)
                if (this.is_export_error_modal) {
                  this.$refs.exportErrorModal.show()
                }
                if (res.data.errors.length > 0) {
                  this.validationErrors = res.data.errors
                  this.errorKeyAbsent = true
                  this.$refs.validationErrorModal.show()
                }
                break
              case 'quickbooks':
              case 'ehr':
                Vue.toasted.show(message)
                break
              case 'fhir':
                this.fhirValues = JSON.parse(res.data.fhir_data)
                this.$refs.fhirModal.show()
                break
            }
          } else {
            switch (res.data.type) {
              case 'salesforce':
                if (res.data.status === 'failed') {
                  form._rowVariant = 'danger'
                  form.sf_export_status = false
                  form.forms_doc_status = res.data.forms_doc_status
                  this.validationErrors = res.data.errors
                  this.$refs.validationErrorModal.show()
                  // this.refreshTab(0, 1)
                }
                break
            }
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          console.log(error)
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    },
    clearFhirData () {
      this.fhirValues = {}
    },
    clearValidationErrorData () {
      this.validationErrors = []
    },
    clearExportErrorData () {
      this.$refs.exportErrorModal.hide()
      this.is_export_error_modal = false
      this.exportErrors = []
      this.med_status_array = []
    },
    confirmReprocess (data) {
      this.selectedFormTitle = data.title
      this.selectedFormDocId = data.id
      this.match_type = null
      this.canShowImgPreview = false
      this.previewImageUrl = ''
      this.forced_template_doc_id = null
      this.$refs.reprocessModal.show()
    },
    reprocessFormDoc () {
      let data = {}
      data.title = this.selectedFormTitle
      data.forced_template_doc_id = this.forced_template_doc_id
      data.account_id = this.accountId
      Vue.axios
        .post('/form_docs/' + this.selectedFormDocId + '/reprocess', data, {
          headers: { Authorization: `Bearer ${this.idToken}` }})
        .then(res => {
          Vue.toasted.show(this.$t('COMMON.MSG_REPROS'))
          this.handleRefresh()
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    moveToMatched (item) {
      Vue.axios.get('/form_docs/' + item.id + '/change_unmatched_status', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.status === 200) {
            Vue.toasted.show('Form Update Success')
          } else if (res.status === 201) {
            Vue.toasted.show(this.$t('COMMON.UNMATCH'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(err => console.log(err))
    },
    processedformsInfoModal (data) {
      let payload = {
        formDocId: data.id
      }
      Vue.axios.post('/form_docs/processed_form_info', payload, {headers: { Authorization: `Bearer ${this.idToken}` }})
        .then(res => {
          this.processed_form_info = res.data.processed_form_info
          this.$refs.processedformsInfo.show()
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    showFormInfo () {
      this.$refs.processedformsInfo.hide()
    },
    confirmDelete (data) {
      this.selectedFormTitle = data.title
      this.selectedFormDocId = data.id
      this.$refs.formDelModal.show()
    },
    deleteFormDoc () {
      let formDocId = this.selectedFormDocId
      Vue.axios
        .delete('/form_docs/' + formDocId, {
          headers: { Authorization: `Bearer ${this.idToken}` }})
        .then(res => {
          if (res.status === 200) {
            let deletedFormDoc = parseInt(res.data.formDocId[0])
            this.processedData = this.processedData.slice(0).filter(function (doc, index) { return doc.id !== deletedFormDoc })
            this.$store.dispatch('updateProcessedData', this.processedData)
            Vue.toasted.show(res.data.status)
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.forms-table {
  max-height: 35rem;
  overflow-x: scroll;
  overflow-y: scroll;
  border-radius: 0 0 10px 10px;
}

.btn.btn-primary.btn-sm:disabled {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

.result {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
}

/deep/ .table.b-table>thead>tr>th.sorting_asc::after, table.b-table>thead>tr>th.sorting_desc::before, table.b-table>tfoot>tr>th.sorting_asc::after, table.b-table>tfoot>tr>th.sorting_desc::before {
    opacity: 1;
}
/deep/ .table.b-table>thead>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::after {
    right: 0.25em;
    content: "\2193";
}
/deep/ .table.b-table>thead>tr>th.sorting::before, table.b-table>thead>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::after {
    position: absolute;
    bottom: 3px;
    display: block;
    padding-bottom: inherit;
    font-size: inherit;
    line-height: 180%;
    transform: rotate(180deg);
}
/deep/ .table.b-table>thead>tr>th.sorting_asc::after, table.b-table>thead>tr>th.sorting_desc::before, table.b-table>tfoot>tr>th.sorting_asc::after, table.b-table>tfoot>tr>th.sorting_desc::before {
    opacity: 1;
}
/deep/ .table.b-table>thead>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::before {
    right: 0.75em;
    content: "\2191";
}
/deep/ .table.b-table>thead>tr>th.sorting::after, table.b-table>thead>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::before {
    position: absolute;
    bottom: 3px;
    display: block;
    padding-bottom: inherit;
    font-size: inherit;
    line-height: 180%;
    transform: rotate(180deg);
}
table {
  border-collapse: collapse;
  border-spacing: 0 0em;
}
 /deep/ .table td {
  padding: 3px !important;
  max-width: 95px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .table th, td {
  padding: 6px !important;
}
/deep/ .small-cell-width{
  min-width: 90px;
}
/deep/ .medium-cell-width{
  min-width: 150px;
}

/deep/ .large-cell-width{
  min-width: 200px;
}

/deep/ .semi-medium-cell-width{
  min-width: 140px;
}
/deep/ .small-cell-width{
  min-width: 90px
}
/deep/ .medium-cell-width{
  min-width: 150px
}

/deep/ .xmedium-cell-width{
  min-width: 160px
}

/deep/ .large-cell-width{
  min-width: 200px
}
table {
  border-collapse: collapse;
  border-spacing: 0 0em;
}
 /deep/ .table td {
  padding: 3px !important;
}
/deep/ .table th, td {
  padding: 6px !important;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.reprocess-input {
  border-radius: 20px;
  padding: 8px 15px;
}

.new_forms_processed {
  position: relative;
  left: 40%;
  border-radius: 5px 5px 5px 5px;
}

.hide {
  display: none;
}
.disabled {
  cursor: not-allowed;
}
</style>
<style lang="scss">
.processed-form{

  .nav-tabs .nav-link.active {
    color: white !important;
    border-bottom: 1px solid #0e2547 !important;
    border-radius: 5px 5px 0 0;
    background: linear-gradient(to top, #0e2547 90%, rgba(17,90,186,1) 91%) !important;
  }

  .tab-content .tab-pane {
    padding:0;
  }

  .nav-tabs .nav-link{
    color: black;
  }

  .nav-link.disabled {
    cursor: not-allowed;
  }
}
.warning-bg-con-color{
  background-color: #fdf8e1;
}
.warning-con {
  padding: 0.7rem;
  margin: -1rem;
}
.custom-btn {
  background-color: white;
  color: black;
  border: 1px solid black;
  border-radius: 10px;
  padding: 6px 12px;
  transition: background-color 0.3s ease;
}
.custom-btn:hover {
  background-color: #34528d;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/process/ProcessedForms.vue